module.exports = __webpack_public_path__ + "a59a3f3b290a372cead709b2b0a0de2f.MP3";